import React from "react";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from "styled-components"

import * as periodActions from '../periods/period.actions';
import * as irraction from './irr.actions';
import * as sampleActions from '../sample/sample.actions';
import * as selectors from './irr.selectors';
import * as sampleSelectors from '../sample/sample.selectors';
import * as applicationActions from "../../application.actions";
import * as applicationSelectors from "../../application.selectors";
import * as periodSelectors from "../periods/period.selectors";
import { AgGridReact as Grid } from "ag-grid-react";
import { DateRenderer, PrimaryButton, DefaultButton, WarningButton, Modal } from "../../components";
import { Button } from "react-bootstrap";
import { IrrNurseGrid } from "./components/irrNurseGrid";
import { irrs } from "../../store/schema";

const Container = styled.div``

class Irr extends React.Component {
  state = {
    showModal: false,
    quarters: [],
    irrFormErrors: []
  };
  years = [];

  componentDidMount() {
    setTimeout(() => this.setState({ show: true }), 1500);

    const oldest = 2020;
    for (let i = oldest; i <= new Date().getFullYear(); i++) { this.years.push(i) };

    const {
      roles,
      actions: { setPageTitle, fetchIrrs, setBreadcrumbs, fetchPeriods, fetchPeriod },
    } = this.props
    fetchPeriods();
    fetchIrrs();
    setPageTitle("Interrater Reliability Monitoring (IRR)");
    setBreadcrumbs([{ active: true, title: "IRR" }]);
  }
  showModal = (period, nurses) => () => this.setState(({ showModal: true, period, nurses }));
  hideModal = () => this.setState(({ showModal: false }));
  render() {
    const { irrs, periods, history, irrRoles } = this.props;
    return (
      <Container>
        <div className="text-right generate-button-wrapper"><PrimaryButton onClick={this.showModal()}>Generate IRR</PrimaryButton></div>
        <IrrNurseGrid irrRoles={irrRoles} nurses={irrs} history={history} rowDelete={this.deleteIrrClick} rowReview={this.reviewIrrClick} periods={periods}></IrrNurseGrid>
        {this.renderModal()}
      </Container>
    )
  }
  renderModal() {
    const { showModal, quarters } = this.state;
    const { periods, nurses, actions: { generateIrr } } = this.props;
    const years = periods.map(p => new Date(p.periodStart.replace("Z", "")).getFullYear()).filter(this.distinct);
    const {yearErr, quarterErr, nurseErr} = this.state.irrFormErrors;
    
    return (
      <Modal
        show={showModal}
        title="Generate IRR Sample"
        onClose={this.hideModal}
        body={<div>
          <div className="row">
            <div className="col-sm-1 generateIrrLabel">
              <label>Year</label> <br />
                <select onChange={this.yearSelected} className={yearErr ? "form-control validation-error" : "form-control"}>
                  <option key={null} value={null}>-Select-</option>
                  {years.map(this.renderYearSelects)}
                </select>
              {yearErr && <div style={{color: "#9e1f35", textAlign: "left", height : '10px', width : '10px'}}><i className="glyphicon glyphicon-remove"></i></div>}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-1 generateIrrLabel">
              <label>Quarter</label> <br />
              <select value={this.state.selectedQuarterId} onChange={this.quarterSelected} disabled={!this.state.year} className={quarterErr ? "form-control validation-error" : "form-control"}>
                <option key={null} value={''}>-Select-</option>
                {quarters.map(this.renderQuarters)}
              </select>
              {quarterErr && <div style={{color: "#9e1f35", textAlign: "left"}}><i className="glyphicon glyphicon-remove"></i></div>}
            </div>
            <div className="col-sm-1 generateIrrLabel">
              <label>Reviewed Nurse</label> <br />
              <select value={this.state.selectedNurseId} onChange={this.nurseSelected} disabled={!this.state.selectedQuarterId} className={nurseErr ? "form-control validation-error" : "form-control"}>
                <option key={null} value={''}>-Select-</option>
                <option key="All" value="All">All</option>
                {nurses.filter(this.distinct).map(this.generateNurseSelects)}
              </select>
              {nurseErr && <div style={{color: "#9e1f35", textAlign: "left"}}><i className="glyphicon glyphicon-remove"></i></div>}
            </div>
          </div>
        </div>}
        footer={
          <React.Fragment>
            <DefaultButton onClick={this.handleCancel}>Cancel</DefaultButton>
            <WarningButton onClick={this.generateIrrClick}>Generate</WarningButton>
          </React.Fragment>
        }
      />
    )
  }
  distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  }
  nurseSelected = (event) => {
    console.log(`Nurse selected: ${event.target.value}`)
    this.setState({
      ...this.state,
      selectedNurseId: event.target.value === '-Select-' ? null : event.target.value
    });
  }
  generateNurseSelects = (nurse) => {
    return <option key={nurse} value={nurse}>{nurse}</option>
  }
  unUTCDate = (dateStr) => {
    return dateStr.replace("Z", "");
  }
  quarterSelected = (event) => {
    const period = event.target.value;
    const {nurseErr} = this.state.irrFormErrors;
    this.setState({
      ...this.state,
      selectedQuarterId: ''
    });
    if ("-Select-" == period) { this.setState({...this.state, selectedNurseId: ''});return; }

    const { actions: { fetchPeriod } } = this.props;
    fetchPeriod(period);
    this.setState({
      ...this.state,
      irrFormErrors: [],
      selectedQuarterId: period
    });
  }
  yearSelected = (event) => {
    if (!event.target.value) return;

    const { periods } = this.props;
    const { nurseErr, quarterErr } = this.state.irrFormErrors;
    const selectedPeriods = periods.filter(p => {
      const dateStr = this.unUTCDate(p.periodStart);
      const year = new Date(dateStr).getFullYear();
      return event.target.value == year;
    });
    this.setState({
      ...this.state,
      year: event.target.value === '-Select-' ? null : event.target.value,
      selectedQuarterId: '',
      selectedNurseId: '',
      irrFormErrors: [],
      quarters: selectedPeriods.map(m =>
      ({
        periodStart: m.periodStart,
        periodEnd: m.periodEnd,
        id: m.id,
        quarter: `Q${(new Date(this.unUTCDate(m.periodEnd)).getMonth() + 1) / 3}`
      }))
    });
  }
  renderYearSelects = (year) => {
    return <option key={year} value={year}>{year}</option>;
  }
  renderQuarters = (quarter) => {
    return <option key={quarter.id} value={quarter.id}>{quarter.quarter}</option>
  }
  generateIrrClick = (event) => {
    event.preventDefault();

    if(this.handleValidation()) {
      const { irrRoles, nurses, actions: { generateIrr } } = this.props;
      const nurseParam = this.state.selectedNurseId == "All" ? nurses.filter(this.distinct) : [this.state.selectedNurseId];
      const body = {
        nurses: nurseParam,
        irrType: irrRoles.mqd ? 2 : irrRoles.hsag ? 1 : 0
      }
      generateIrr(this.state.selectedQuarterId, body);
      this.setState({
        ...this.state,
        selectedNurseId: '',
        selectedQuarterId: '',
        year: '',
        irrFormErrors: []
      });
      this.hideModal();
    }
  }

  deleteIrrClick = (irr) => {
    const {irrRoles, actions: { deleteIrr } } = this.props;
    deleteIrr(irr.id, irr.periodId);
  }

  handleCancel = (event) => {
    this.setState({
      irrFormErrors: [],
      selectedNurseId: '',
      selectedQuarterId: '',
      year: ''
    });
    this.hideModal();
  }
  reviewIrrClick = (row) => {

  }
  handleValidation() {
    const {raiseError} = this.props.actions;
    const {year, selectedQuarterId, selectedNurseId} = this.state;
    var formIsValid = true;
    var formErrors = [];
    if(!year || year === '-Select-') {
      formIsValid = false;
      formErrors["yearErr"] = "Year is required";
    }

    if(!selectedQuarterId || selectedQuarterId === '-Select-') {
      formIsValid = false;
      formErrors["quarterErr"] = "Quarter is required";
    }

    if(!selectedNurseId || selectedNurseId === '-Select-') {
      formIsValid = false;
      formErrors["nurseErr"] = "Nurse is required"
    }

    if(!formIsValid) {
      raiseError("There are errors on form.");
    }
    this.setState({ irrFormErrors: formErrors});
    return formIsValid;
  }
}


export default withRouter(
  connect(
    (state) => ({
      roles: applicationSelectors.roles(state),
      irrRoles: applicationSelectors.irrRoles(state),
      fetching: state.irrs.fetching,
      irrs: selectors.irrs(state),
      periods: periodSelectors.periods(state),
      nurses: sampleSelectors.reviewersWithRecords(state),
      patients: sampleSelectors.includedPatients(state)
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...applicationActions,
          ...irraction,
          ...periodActions,
          ...sampleActions
        },
        dispatch
      ),
    })
  )(Irr));



// WEBPACK FOOTER //
// ./src/modules/irr/index.js